import { render, staticRenderFns } from "./form-representatives-promotor.vue?vue&type=template&id=33e67de6&scoped=true"
import script from "./form-representatives-promotor.vue?vue&type=script&lang=js"
export * from "./form-representatives-promotor.vue?vue&type=script&lang=js"
import style0 from "./form-representatives-promotor.vue?vue&type=style&index=0&id=33e67de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e67de6",
  null
  
)

export default component.exports